import type { Organization } from "~/interface/organization";
import type { User } from "~/interface/user";
import type { NotAuthenticatedUserInfo } from "~/interface/userInfo";

export function initUserInfo(): NotAuthenticatedUserInfo {
  return {
    id: "",
    ad_id: undefined,
    email: "",
    user_data: [],
  };
}

export function initCurrentUser(): User {
  return {
    id: "",
    userInfo_id: "",
    status: "invited",
    organization_id: "",
    first_name: "",
    last_name: "",
    display_name: "",
    role: "guest",
  };
}

export function initOrganization(): Organization {
  return {
    id: "",
    root_user_id: "",
    name: "",
    payment_id: "",
    url: "",
    status: "active",
    remainingCredit: 0,
    remainingChatRequests: 0,
    remainingAppGenerationCount: 0,
    plan: {
      type: "free",
      limits: {
        maxMembers: 1,
        maxGuests: 0,
        maxProjects: 1,
        monthlyLimit: 100,
        monthlyRequestLimit: 100,
        appGenerationCount: 3,
        appGenerationCreditCost: 25,
      },
      features: {
        summary: true,
        "system-proposal": true,
        estimation: true,
        "functional-requirements": true,
        "non-functional-requirements": true,
        workflow: true,
        "plugin-proposal": true,
        "app-design": true,
        "field-design": true,
        "entity-relationship": true,
        "system-architecture": true,
        "customize-specification": true,
        reverse: true,
      },
    },
    rootUser: {
      id: "",
      firstName: "",
      lastName: "",
      displayName: "",
    },
  };
}
